import React, { useState, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../../store';
import { InventoryInfo } from '../../types/interface';

export const Inventory: React.FC = () => {
  const navigate = useNavigate();
  const { inventory, equipped } = useUserStore((state) => state.user);
  const tg = window.Telegram.WebApp;

  const [isLoading, setIsLoading] = useState(true);

  const reversedInventory = useMemo(() => {
    const combinedInventory = [
      ...(inventory ?? []),
      ...(equipped ?? [])
    ];

    return [...combinedInventory].reverse();
  }, [inventory, equipped]);

  const handleItemClick = useCallback(
    (item: InventoryInfo) => {
      const isEquipped = equipped?.some((equippedItem) => equippedItem.good.id === item.good.id);
      const categories = inventory?.filter((one) => one.good.type === item.good.type);

      if (isEquipped || !categories || categories.length === 0) {
        return;
      }

      tg.BackButton.show();

      navigate(`/inventory/details/${item.good.id}`);
    },
    [inventory, equipped, navigate, tg.BackButton]
  );

  if (!(reversedInventory?.length)) {
    return <span className="text-white opacity-60 flex text-sm">No items yet</span>;
  }

  return (
    <div className="grid gap-3 grid-cols-4">
      {reversedInventory
      .filter(item => {
        const isEquipped = equipped?.some((equippedItem) => equippedItem.good.id === item.good.id);

        if (isEquipped && item.amount === 1) {
          return false;
        }

        return true;
      })
      .map((item, index) => {
        const isEquipped = equipped?.some((equippedItem) => equippedItem.good.id === item.good.id);

        return (
          <div key={index} className="relative rounded-2xl">
            <button
              onClick={() => handleItemClick(item)}
              className={`relative z-[1] rounded-2xl bg-transparent w-full h-auto pointer-events-auto ${
                isEquipped ? 'opacity-25' : ''
              }`}
            >
              <img
                src={item.good.img}
                alt="item"
                className="rounded-2xl w-full h-full"
                onLoad={() => setIsLoading(false)}
              />
              {isLoading && (
                <div className="absolute top-0 left-0 w-full h-full bg-slate-700 animate-pulse rounded-2xl" />
              )}
            </button>
            {item.amount > 1 && (
              <span className="absolute z-[2] left-1 top-1 bg-gray-800/[.6] rounded-lg font-bold text-xs text-white px-2">
                x{item.amount - (isEquipped ? 1 : 0)}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};
